module.exports = __webpack_public_path__ + "img/resources-article-pilates-massage@2x.f2272022.jpg";